import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./productcomponents.css";
import { addToCart } from "../../utils/addtocart";
import LoginPopup from "../Login/loginPopup";
const ProductCard = ({ product }) => {
  const [quantity, setQuantity] = useState(1);
  const navigate = useNavigate();
  const [showLogin, setShowLogin] = useState(false);
  const [added, setAdded] = useState(false);
  const handleAddToCart = (e) => {
    e.stopPropagation(); // prevent navigation when clicking button
    alert(`Added ${quantity} item(s) to cart`);
  };

  const handleNavigate = () => {
    navigate(`/product-details/${product.id}`);
  };

  return (
    <>

      <div className="product-card" onClick={handleNavigate}>

        <div className="product-card-image">
          <img src={product.image} alt={product.name} />
        </div>

        <div className="product-card-details">
          <div className="product-card-header">
            <h3 className="product-card-title">{product.name}</h3>
            <span className="product-card-price">
              ₹{product.price} <small>(incl. GST)</small>
            </span>
          </div>

          <p className="product-card-description">
            {product.description}
          </p>

          <div className="product-card-footer">
            <div className="product-card-actions">

              <div className="product-card-quantity">
                <button
                  className="quantity-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    setQuantity(q => Math.max(1, q - 1));
                  }}
                >
                  -
                </button>

                <span className="quantity-value">{quantity}</span>

                <button
                  className="quantity-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    setQuantity(q => q + 1);
                  }}
                >
                  +
                </button>
              </div>


              <button
                className={`product-card-cart-btn ${added ? "added" : ""}`}
                onClick={async (e) => {
                  e.stopPropagation();

                  const success = await addToCart(product, quantity, () => setShowLogin(true));

                  if (success) {
                    setAdded(true);

                    setTimeout(() => {
                      setAdded(false);
                    }, 1500);
                  }
                }}
              >
                {added ? "✓ Added" : "Add to Cart"}
              </button>



            </div>
          </div>
        </div>
      </div>
      <LoginPopup
        show={showLogin}
        onClose={() => setShowLogin(false)}
      />
    </>
  );
};

export default ProductCard;